import { render } from "./skill.vue?vue&type=template&id=18cd9804&scoped=true"
import script from "./skill.vue?vue&type=script&lang=js"
export * from "./skill.vue?vue&type=script&lang=js"

import "./skill.vue?vue&type=style&index=0&id=18cd9804&scoped=true&lang=css"

import exportComponent from "D:\\pro\\edu-hsd\\cxcj\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18cd9804"]])

export default __exports__